(function () {
  var dialog = document.getElementById('puddleford-find-your-size');
  if (!dialog) return;

  var input = dialog.querySelector('#pf-fys-cm');
  var showButton = dialog.querySelector('[data-fys-show]');
  var addButton = dialog.querySelector('[data-fys-add]');
  var closeButton = dialog.querySelector('[data-fys-close]');
  var resultBlock = dialog.querySelector('[data-fys-result]');
  var resultSizeEl = dialog.querySelector('[data-fys-result-size]');
  var resultLineEl = dialog.querySelector('[data-fys-result-line]');
  var rows = dialog.querySelectorAll('tr[data-size]');

  var SIZES = [
    { code: 'XS', min: -Infinity, max: 35, label: 'Extra small', range: '27–35 cm' },
    { code: 'S', min: 36, max: 45, label: 'Small', range: '36–45 cm' },
    { code: 'M', min: 46, max: 55, label: 'Medium', range: '46–55 cm' },
    { code: 'L', min: 56, max: 66, label: 'Large', range: '56–66 cm' },
    { code: 'XL', min: 67, max: Infinity, label: 'Extra large', range: '67–80 cm' },
  ];

  var variantsScript = document.getElementById('puddleford-robe-variants-for-size');
  var variants = [];
  if (variantsScript) {
    try {
      variants = JSON.parse(variantsScript.textContent);
    } catch (e) {
      variants = [];
    }
  }

  var currentSize = null;

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-open-find-your-size]');
    if (trigger) {
      event.preventDefault();
      dialog.showModal();
    }
  });

  closeButton.addEventListener('click', function () {
    dialog.close();
  });

  dialog.addEventListener('click', function (event) {
    if (event.target === dialog) dialog.close();
  });

  function matchSize(cm) {
    for (var i = 0; i < SIZES.length; i++) {
      if (cm >= SIZES[i].min && cm <= SIZES[i].max) return SIZES[i];
    }
    return null;
  }

  showButton.addEventListener('click', function () {
    var cm = parseFloat(input.value);
    if (isNaN(cm) || cm <= 0) {
      input.focus();
      return;
    }

    var size = matchSize(cm);
    if (!size) return;

    currentSize = size;
    resultSizeEl.textContent = size.code;
    resultLineEl.textContent = size.label + ' fits a ' + size.range + ' back';
    resultBlock.hidden = false;

    rows.forEach(function (row) {
      row.classList.toggle('pf-fys__match', row.getAttribute('data-size') === size.code);
    });
  });

  addButton.addEventListener('click', function () {
    if (!currentSize || !variants.length) return;

    var match = variants.find(function (v) {
      return (v.options || []).indexOf(currentSize.code) !== -1;
    });
    if (!match) return;

    addButton.disabled = true;
    addButton.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: match.id, quantity: 1 }] }),
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Add to cart failed');
        window.location.href = '/cart';
      })
      .catch(function () {
        addButton.disabled = false;
        addButton.textContent = 'Add this size to basket';
      });
  });
})();
